module.exports = __webpack_public_path__ + "media/images/phtext-eb529169f5cf7381f7fc9d675c0f2a45.svg";